import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 border-t border-gray-800" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12" data-id="element-81">
          {/* Col 1 */}
          <div data-id="element-82">
            <div className="flex items-center gap-2 mb-4 text-white" data-id="element-83">
              <LockIcon className="w-5 h-5" data-id="element-84" />
              <h3 className="font-bold text-lg" data-id="element-85">Pagamento Sicuro</h3>
            </div>
            <p className="text-sm mb-6" data-id="element-86">
              Protetto con crittografia SSL e sistemi di pagamento affidabili.
            </p>
            <div className="flex justify-start" data-id="element-87">
              <PaymentBadges data-id="element-88" />
            </div>
          </div>

          {/* Col 2 */}
          <div data-id="element-89">
            <h3 className="font-bold text-lg text-white mb-4" data-id="element-90">Link Utili</h3>
            <ul className="space-y-3 text-sm" data-id="element-91">
              <li data-id="element-92">
                <a href="#" className="hover:text-white transition-colors" data-id="element-93">
                  Termini e Condizioni
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-white transition-colors" data-id="element-95">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="hover:text-white transition-colors" data-id="element-97">
                  Informativa sui Cookie
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-98">
            <h3 className="font-bold text-lg text-white mb-4" data-id="element-99">Contattaci</h3>
            <div className="flex items-center gap-2 text-sm" data-id="element-100">
              <MailIcon className="w-4 h-4" data-id="element-101" />
              <a href="mailto:info@activapleno.com" className="hover:text-white transition-colors" data-id="element-102">
                info@activapleno.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-xs text-center space-y-4" data-id="element-103">
          <p data-id="element-104">
            Questo è un prodotto digitale. Nessun prodotto fisico verrà spedito.
          </p>
          <p data-id="element-105">
            Questo sito non è parte di Facebook né è in alcun modo approvato da
            Facebook.
          </p>
          <p data-id="element-106">
            &copy; {new Date().getFullYear()} MegaPack Maestro Musicale 360°.
            Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>;
}